export default __webpack_public_path__ + "static/media/account-banned.bb86fea2.svg";